import React from "react"
import {DeliveryContainer, TotalValue} from "./components"
import {PriceWrapperItem, StyledActionsContainer, TotalText} from "../../component"

export type StandardPriceAndDeliveryInfoProps = {
    isFirstSection: boolean
    totalText: string
    finalOrderValueFormatted: string
    description: string
}

export const StandardPriceAndDeliveryInfo = ({
    isFirstSection,
    totalText,
    finalOrderValueFormatted,
    description,
}: StandardPriceAndDeliveryInfoProps) => {
    return (
        <StyledActionsContainer isFirstSection={isFirstSection}>
            <PriceWrapperItem>
                <TotalText>{totalText}</TotalText>
                <TotalValue variant="body3" data-testid="header-mini-shopping-bag-total">
                    {finalOrderValueFormatted}
                </TotalValue>
            </PriceWrapperItem>
            <DeliveryContainer>
                <span>{description}</span>
            </DeliveryContainer>
        </StyledActionsContainer>
    )
}

export default StandardPriceAndDeliveryInfo
